var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import EnvironmentService from "../EnvironmentService.js";
import { newGuid } from "../GuidHelper.js";
import { ConsoleLogProvider } from "./ConsoleLogProvider.js";
import { getErrorPayload } from "./Logger.utils.js";
var ErrorType = /* @__PURE__ */ ((ErrorType2) => {
  ErrorType2["Msal"] = "msal";
  ErrorType2["LoadResourceComplete"] = "loadResourceComplete";
  ErrorType2["OnErrorDecorator"] = "onErrorDecorator";
  ErrorType2["CallLoadResourcePromiseError"] = "callLoadResourcePromiseError";
  ErrorType2["CallLoadResourceError"] = "callLoadResourceError";
  ErrorType2["LoadResourceCompleteUnsuccessful"] = "loadResourceCompleteUnsuccessful";
  ErrorType2["LoadResourceCompleteGetSuccessDataException"] = "loadResourceCompleteGetSuccessDataException";
  ErrorType2["LoadedAction"] = "loadedAction";
  ErrorType2["RestServiceBaseEnsureSuccessFailed"] = "restServiceBaseEnsureSuccessFailed";
  ErrorType2["ErrorBoundary"] = "errorBoundaryException";
  ErrorType2["FlightEpics"] = "flightEpics";
  ErrorType2["Promise"] = "promiseError";
  ErrorType2["ProgressionsPromise"] = "progressionsPromiseError";
  ErrorType2["ProgressionsDropdown"] = "progressionsDropdown";
  ErrorType2["LegacyDropdown"] = "legacyDropdown";
  ErrorType2["LoaderGetManifest"] = "loaderGetManifestError";
  ErrorType2["InitialLoader"] = "initialLoaderError";
  ErrorType2["BootstrapperUnknown"] = "bootstrapperUnknownError";
  ErrorType2["BootstrapperListenerUnknown"] = "bootstrapperListenerUnknownError";
  ErrorType2["ControlTowerError"] = "controlTowerError";
  ErrorType2["Test"] = "Test";
  return ErrorType2;
})(ErrorType || {});
function customErrorObject(errorOrString, thrownFrom) {
  let rethrow = typeof errorOrString == "string" ? Error(errorOrString) : errorOrString;
  rethrow.errorCorrelationId = rethrow.errorCorrelationId || newGuid();
  rethrow.thrownFrom = [...rethrow.thrownFrom || [], thrownFrom];
  return rethrow;
}
const _LoggerImplementation = class _LoggerImplementation {
  /**
   * Creates an instance of LoggerImplementation.
   *
   * @param {ILogProvider[]} _providers
   *
   * @memberOf LoggerImplementation
   */
  constructor(_providers) {
    __publicField(this, "_equalityMethod");
    __publicField(this, "lastCall", null);
    __publicField(this, "_preLogger", null);
    __publicField(this, "_standardLoggingPropertiesData", {
      impressionId: null,
      routeViewName: null,
      routeViewNormalizedName: null,
      routeViewTime: null,
      routeVisitCount: 0,
      totalRouteVisitCount: 0,
      workspaceId: null,
      userManagementGroup: null,
      entityWorkspaceId: null,
      entityManagementGroup: null,
      isUserAnEOnly: null,
      experience: "NotSet",
      inIframe: false,
      isLocallyServed: false,
      isProduction: false,
      version: "NotSet",
      hostname: "NotSet"
    });
    __publicField(this, "_totalRouteVisitCount", 0);
    __publicField(this, "_pageViewRouteVisitCount", {});
    __publicField(this, "_treatmentAssignmentResult", null);
    this._providers = _providers;
    if (!this._providers) {
      this._preLogger = new PreLoggerProvider();
      this.setProviders([new ConsoleLogProvider(), this._preLogger.getCachedLogger()]);
    }
    this._equalityMethod = (l, r) => l === r;
  }
  /**
   * Adds a log provider
   * @description Note: the order of events, this is best to be added via the ctor.
   * This is used as a way to add the bct interop provider after startup.
   * @param provider The provider to subscribe to logging events
   */
  static addLogProvider(provider) {
    if (provider) {
      this.getInstance();
      this._instance._providers.push(provider);
    }
  }
  /**
   * Initializes the logger with new additional log providers
   * @description Note: the order of events, this is best to be added via the ctor.
   * @param newProvider {ILogProvider[]} The providers to subscribe to logging events
   */
  static initialize(newProviders) {
    this.getInstance();
    this._instance.initialize(newProviders);
  }
  static setEqualityMethod(comparer) {
    this.getInstance();
    this._instance.setEqualityMethod(comparer);
  }
  /**
   * @static
   * @returns {LoggerImplementation}
   *
   * @memberOf LoggerImplementation
   */
  static getInstance() {
    if (!this._instance) {
      this._instance = new _LoggerImplementation();
      window["rootLogger"] = this._instance;
    }
    return this._instance;
  }
  // this is a method passed to the ApplicationInsightsLogProvider so it can "globally" log
  // pageview data (via addTelemetryInitializer())
  standardLoggingPropertiesProvider() {
    return __spreadProps(__spreadValues({}, this._standardLoggingPropertiesData), {
      // these values could be dynamic, so get the latest values
      inIframe: EnvironmentService.isIframe,
      isLocallyServed: EnvironmentService.isLocallyServed,
      isProduction: EnvironmentService.isProduction__DontUseForBranchingCode_OnlyUseForLoggingEnvironment,
      version: EnvironmentService.getVersion(),
      hostname: window.location.hostname
    });
  }
  initialize(newProviders) {
    let result = void 0;
    if (newProviders) {
      const preLogger = this._preLogger;
      if (preLogger) {
        const oldProviders = this._providers.filter((p) => p !== preLogger.preLogProvier);
        this.setProviders(newProviders);
        this.lastCall = {};
        result = preLogger.replayEvents((method, event) => this.broadCast(method, event));
        this.setProviders(oldProviders);
        delete this._preLogger;
      }
      newProviders.forEach((p) => this._providers.push(p));
      return result || Promise.resolve();
    }
  }
  warn(msg, properties) {
    const event = {
      message: msg,
      properties
    };
    this.populateProperties(event);
    this.broadCast((l) => l.warn, event);
  }
  info(msg, properties) {
    const event = {
      message: msg,
      properties
    };
    this.populateProperties(event);
    this.broadCast((l) => l.info, event);
  }
  log(msg, properties) {
    const event = {
      message: msg,
      properties
    };
    this.populateProperties(event);
    this.broadCast((l) => l.log, event);
  }
  error(msgOrError, errorTypeName, properties) {
    let errorCorrelationId = (properties == null ? void 0 : properties.errorCorrelationId) || msgOrError.errorCorrelationId || newGuid();
    let correlationId = (properties == null ? void 0 : properties.correlationId) || msgOrError.correlationId;
    let message = typeof msgOrError == "string" ? msgOrError : msgOrError.message;
    let isUserError = msgOrError.isUserError;
    properties = __spreadProps(__spreadValues({}, properties), {
      errorType: errorTypeName,
      errorCorrelationId
    });
    const payload = getErrorPayload(msgOrError, properties);
    if (!!payload) {
      this.populateProperties(payload);
      if (typeof msgOrError === "string") {
        this.broadCast((l) => l.error, payload);
      } else {
        this.broadCast((l) => l.exception, payload);
      }
      this.trackMetric({
        name: "error",
        average: 1,
        properties: {
          errorType: errorTypeName,
          errorCorrelationId,
          correlationId,
          isUserError,
          message
        }
      });
    }
  }
  setUserManagementGroupAndWorkspaceId(userManagementGroup, workspaceId) {
    this._standardLoggingPropertiesData.userManagementGroup = userManagementGroup;
    this._standardLoggingPropertiesData.workspaceId = workspaceId;
  }
  setEntityManagementGroupAndWorkspaceId(entityManagementGroup, entityWorkspaceId) {
    this._standardLoggingPropertiesData.entityWorkspaceId = entityWorkspaceId;
    this._standardLoggingPropertiesData.entityManagementGroup = entityManagementGroup;
  }
  setEntityManagementGroup(entityManagementGroup) {
    this._standardLoggingPropertiesData.entityManagementGroup = entityManagementGroup;
  }
  setEntityWorkspaceId(entityWorkspaceId) {
    this._standardLoggingPropertiesData.entityWorkspaceId = entityWorkspaceId;
  }
  setIsUserAnEOnly(isUserAnEOnly) {
    this._standardLoggingPropertiesData.isUserAnEOnly = isUserAnEOnly;
  }
  setApplicationExperience(experience) {
    this._standardLoggingPropertiesData.experience = experience;
  }
  setAndLogTreatmentAssignmentResult(treatmentAssignmentResult) {
    this._treatmentAssignmentResult = treatmentAssignmentResult;
    this.logTreatmentAssignmentResult();
  }
  logTreatmentAssignmentResult() {
    if (!this._treatmentAssignmentResult) {
      return;
    }
    this.trackMetric({
      name: `TreatmentAssignment`,
      average: performance.now(),
      properties: __spreadValues({}, this._treatmentAssignmentResult)
    });
  }
  routeView(routeView) {
    const id = newGuid();
    const routeViewName = routeView.name;
    this._pageViewRouteVisitCount[routeViewName] = this._pageViewRouteVisitCount[routeViewName] + 1 || 1;
    this._totalRouteVisitCount++;
    this._standardLoggingPropertiesData.impressionId = id;
    this._standardLoggingPropertiesData.routeViewName = routeViewName;
    const guid_regex = /(\b[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}\b)/gi;
    const num_regex = /(\b\d+\b)/gi;
    this._standardLoggingPropertiesData.routeViewNormalizedName = routeViewName.replace(guid_regex, "[id]").replace(num_regex, "[id]");
    this._standardLoggingPropertiesData.routeViewTime = performance.now();
    this._standardLoggingPropertiesData.routeVisitCount = this._pageViewRouteVisitCount[routeViewName];
    this._standardLoggingPropertiesData.totalRouteVisitCount = this._totalRouteVisitCount;
    this.logTreatmentAssignmentResult();
  }
  pageView(pageView) {
    pageView.id = pageView.id || newGuid();
    this.populateProperties(pageView);
    this.broadCast((l) => l.pageView, pageView);
  }
  trackEvent(event) {
    this.populateProperties(event);
    this.broadCast((l) => l.trackEvent, event);
  }
  trackMetric(metric) {
    this.populateProperties(metric);
    this.broadCast((l) => l.trackMetric, metric);
  }
  // NOTE: this is not actually used.  AppInsights logs dependencies automatically
  trackDependency(dependency) {
    dependency.id = dependency.id || newGuid();
    this.broadCast((l) => l.trackDependency, dependency);
  }
  clickEvent(componentType, properties) {
    const clickEventProperties = __spreadValues({
      type: "default"
    }, properties.clickEventProperties);
    const loggerProperties = {
      componentType,
      context: JSON.stringify(clickEventProperties.context),
      eventName: clickEventProperties.name,
      eventType: clickEventProperties.type,
      href: properties.href,
      text: properties.text,
      action: clickEventProperties.action,
      dataTelemetryId: properties.dataTelemetryId
    };
    const event = {
      measurements: {},
      name: "ClickEvent",
      properties: loggerProperties
    };
    this.trackEvent(event);
  }
  setEqualityMethod(comparer) {
    this._equalityMethod = comparer;
  }
  setProviders(logProviders) {
    this._providers = logProviders;
  }
  broadCast(logMethod, event) {
    if (this._equalityMethod(this.lastCall, event)) {
      return null;
    }
    this.lastCall = event;
    const catchError = (e, p) => {
      let methodName = void 0;
      for (const m in p) {
        if (p[m] === logMethod(p)) {
          methodName = m;
        }
      }
      this.consoleLogProvider.exception({
        id: newGuid(),
        error: e,
        properties: {
          provider: p.constructor.name,
          logMethod: methodName
        }
      });
    };
    const promises = this._providers.map((p) => {
      try {
        let method = logMethod(p);
        if (typeof method === "function") {
          return Promise.resolve(method.apply(p, [event])).catch((e) => catchError(e, p));
        }
      } catch (e) {
        catchError(e, p);
      }
      return null;
    });
    return Promise.all(promises);
  }
  get consoleLogProvider() {
    for (const p of this._providers) {
      if (p instanceof ConsoleLogProvider) {
        return p;
      }
    }
    return void 0;
  }
  populateProperties(event) {
    event.properties = __spreadValues({}, event.properties);
    return event;
  }
};
/**
 * @private
 * @static
 * @type {LoggerImplementation}
 * @memberOf LoggerImplementation
 */
__publicField(_LoggerImplementation, "_instance");
let LoggerImplementation = _LoggerImplementation;
class PreLoggerProvider {
  constructor() {
    __publicField(this, "preLogProvier", null);
    __publicField(this, "callCache", []);
  }
  getCachedLogger() {
    this.preLogProvier = this.generateILogProvider(
      "warn",
      "info",
      "log",
      "error",
      "exception",
      "pageView",
      "trackEvent",
      "trackMetric",
      "trackDependency"
    );
    return this.preLogProvier;
  }
  replayEvents(broadCastMethod) {
    return Promise.all(
      this.callCache.map((call) => {
        try {
          return broadCastMethod((p) => p[call.methodName], call.arguments[0]);
        } catch (e) {
          return void 0;
        }
      })
    );
  }
  cacheMethod(methodName) {
    const callCache = this.callCache;
    return function(...args) {
      callCache.push({ methodName, arguments: args });
    };
  }
  generateILogProvider(...methodNames) {
    const logProvider = {};
    methodNames.forEach((methodName) => {
      logProvider[methodName] = this.cacheMethod(methodName);
    });
    return logProvider;
  }
}
const logger = LoggerImplementation.getInstance();
export {
  ErrorType,
  LoggerImplementation,
  customErrorObject,
  logger as default
};
//# sourceMappingURL=Logger.js.map
